module.exports = __webpack_public_path__ + "static/media/person10.e8abd7bb.svg";